export default "__VITE_ASSET__BMLwt_h7__"